import styled from 'styled-components';

import { NeuButton } from '@neutron/react';

export const AdhocListContainer = styled.div``;

export const AddEmployeeButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  min-height: 4.5rem;
  padding: 0.125rem 1rem;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px 5px 0px 0px;
`;

// export const AdhocListEmployeesTable = styled(NeuTable)`
//   background: #ffffff;
//   border-radius: 5px;
//   height: calc(100% - 100px);
// `;

// export const AdhocListEmployeesTableBody = styled(NeuTable)`
//   height: calc(100% - 52px);
//   ::-webkit-scrollbar {
//     width: 5px;
//   }
//   ::-webkit-scrollbar-thumb {
//     background: rgb(224, 224, 224);
//     border-radius: 10px;
//   }
// `;

export const EmployeeSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const EmployeeAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 0.5rem;
`;

export const EmployeeNameInTable = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #093865;
`;

export const TextInTable = styled.p`
  font-size: 14px;
  font-style: normal;
  display: flex;
  align-items: center;
  letter-spacing: 0px;
  text-align: left;
  color: #4b4b4b;
`;

export const Meta = styled.div`
  display: flex;
  align-items: center;
`;

export const ManagerNameInTable = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #093865;
`;

export const AddEmployeesBtn = styled(NeuButton)`
  > button {
    font-size: 1rem;
    min-width: 10rem;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
`;

export const RemoveButton = styled(NeuButton)`
  display: flex;
  align-items: center;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  color: #ce3637;
  :hover {
    cursor: pointer;
  }
  > button {
    font-size: 0.75rem;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    padding: 0.25rem 0.75rem;
  }
`;

// TODO: Not currently being used
export const AddEmployeeButton = styled(NeuButton)`
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: bold;
  display: inline-flex;
  margin-top: 35px;
  margin-bottom: 20px;
  margin-left: 22px;
  width: 140px;
  height: 24px;
  gap: spacer-2;
  padding-top: 3px;
  padding-right: spacer-4;
  padding-bottom: 3px;
  padding-left: spacer-3;
  text-align: center;
  align-items: center;
  position: absolute;
  left: 85%;
  bottom: 20%;
`;
